/*
 * @Author: libo 
 * @Date: 2020-11-20 15:16:43 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-05-19 10:54:16
 */

<!-- 抄表异常处理查询 -->
<template>
<a-row :gutter="24" class="new-row">
  <a-col :md="collapsed?0: 5" :sm="24" class="new-col">
    <a-card :bordered="false" class="new-tree-card">
        <!-- 按钮操作区域 -->
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <div style="display: flex;margin-top: 10px;">
            <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
            <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
          </div>
          <!-- 树-->
          <a-col :md="24" :sm="24" class="new-tree-col">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
    </a-card>
  </a-col>
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
      <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
        @click="collapsed = !collapsed"
        class="area-collapsed"></a-icon>
    <a-card :bordered="false" class="new-table-card">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表编号')">
                <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户编号')">
                <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户姓名')">
                <a-input :placeholder="$t('请输入用户姓名')" v-model="queryParam.userName"></a-input>
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表类型')">
                  <!--
                  <a-select v-model="queryParam.mtCode" placeholder="请输入表类型">
                    <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                      {{data.mtCode}}
                    </a-select-option>
                  </a-select>
                  -->
                  <j-dict-select-tag v-model="queryParam.meterType" :placeholder="$t('请选择表类型')" dictCode="meter_type" />
                </a-form-item>
              </a-col>
              <a-col :xl="12" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('告警时间')">
                  <a-range-picker
                    v-model="date"
                    format="YYYY-MM-DD"
                    :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                    @change="onDateRangeChange"
                    @ok="onOk"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('处理状态')">
                  <a-select v-model="queryParam.meterDealStatus" :placeholder="$t('请选择处理状态')">
                    <a-select-option value="0">
                      {{ $t('未处理') }}
                    </a-select-option>
                    <a-select-option value="1">
                      {{ $t('处理中') }}
                    </a-select-option>
                    <a-select-option value="2">
                      {{ $t('已处理') }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!--
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="用户地址">
                  <a-input v-model="queryParam.userState" placeholder="请选择用户地址"  style="width:100%"></a-input>
                </a-form-item>
              </a-col>
              -->
              <!--
            <a-col :xl="24" :lg="7" :md="8" :sm="24"> 
              <a-form-item label="故障类型">
                <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
                  查询全部故障
                </a-checkbox>
                <a-checkbox-group v-model="checkedList" :options="plainOptions" @change="Change" />
              </a-form-item>
            </a-col>
            -->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('故障类型')">
                  <a-select v-model="queryParam.meterWarnType" :placeholder="$t('请选择故障类型')">
                    <a-select-option v-for="key in faultObj" :value="key" :key="key">
                      {{ $t(faultObj[key]) }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button type="primary" icon="download" @click="handleExportXls($t('异常状态'))">{{ $t('导出') }}</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
      <!-- table区域-begin -->
      <div class="table-fixed">
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
          <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
        </div>
        <a-table
          ref="table"
          size="middle"
          tableLayout="fixed"
          bordered
          :scroll="{x: true}"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          :components="drag(columns)"
          @change="handleTableChange">
          <span slot="meterDealDescriptionSlot" slot-scope="text, record" :title="record.meterDealStatus ==1?record.meterDealDescription1:record.meterDealStatus ==2?record.meterDealDescription2:record.meterDealDescription0">
            {{record.meterDealStatus ==1?record.meterDealDescription1:record.meterDealStatus ==2?record.meterDealDescription2:record.meterDealDescription0}}
          </span>
          <span slot="meterDealStatus" slot-scope="text, record">
            <label v-if="record.meterDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
            <label v-else-if="record.meterDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
            <label v-else class="wait-status">{{ $t('未处理') }}</label>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="readingAbnormal(record)" :disabled ="record.meterDealStatus == 2">{{ $t('处理') }}</a>
          </span>
        </a-table>
      </div>
      <meter-readingAbnormal-modal ref="readingAbnormalModal" @ok="modalFormOk"></meter-readingAbnormal-modal>
    </a-card>
  </a-col>
</a-row>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { listSize } from '@/utils/util'
  import { getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import {isUndefined,isEmptyObject} from'@/utils/validate'
  import MeterReadingAbnormalModal from './modules/MeterReadingAbnormalModal'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import { downFile } from '@/api/manage'
  import moment from 'moment'
  import TableDragResize  from '@/mixins/TableDragResize'
  const plainOptions = [
    { value: 1, label: '电池欠压' },
    { value: 2, label: '磁干扰' },
    { value: 3, label: '存储器故障' },
    { value: 4, label: '逆流故障' },
    { value: 5, label: '阀门故障' },
  ];
  const faultObj= {
    1: '电池欠压',
    2: '磁干扰',
    3: '存储器故障',
    4: '逆流故障',
    5: '阀门故障'};
  const all = [];
  const defaultCheckedList = [1,2,3,6,8];
  export default {
    name: 'MeterReadingAbnormalList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin,TableDragResize],
    components: {
      MeterReadingAbnormalModal,
    },
    data () {
      return {
        meterTypeObj,
        date:[],
        isAllFault:1,
        all:[],
        indeterminate: false,
        checkAll: false,
        checkedList: defaultCheckedList,
        visible: false,
        userTypeList:[],  //表类型
        faultType:[],   //故障类型
        description: 'meter_up_fault_record管理页面',
        collapsed: false,
        url: {
          list: "/jeecg-charge/meter/meterUpDataFaultRecord/list",
          delete: "/jeecg-charge/meter/meterUpDataFaultRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserinfo/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUpDataFaultRecord/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterUserinfo/importExcel",
          userTypeList:"/jeecg-charge/meter/meterType/list",  //表类型请求地址
        },
        dictOptions:{},
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.loadTree();
      //this.queryUserTypeList()
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：故障类型勾选项（label 随语言切换）
      plainOptions() {
        return plainOptions.map(item => ({ ...item, label: this.$t(item.label) }))
      },
      // i18n：故障类型映射（值随语言切换）
      faultObj() {
        const obj = {}
        Object.keys(faultObj).forEach(k => { obj[k] = this.$t(faultObj[k]) })
        return obj
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'mtName',
            width:100,
            ellipsis: true
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户手机号'),
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true
          },{
            title: this.$t('处理进度'),
            align:"center",
            dataIndex: 'meterDealStatus',
            scopedSlots: { customRender: 'meterDealStatus' },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('故障类型'),
            align:"center",
            dataIndex: 'meterWarnType',
            width:150,
            ellipsis: true,
            customRender: (t,r,index) => {
              let data = faultObj
              if(isUndefined(data[t])) {
                return this.$t('其他')
              }
              return this.$t(data[t])
            },
          },
          {
            title: this.$t('告警时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('处理时间'),
            align:"center",
            dataIndex: 'meterDealTime',
            width:150,
            ellipsis: true
          },
        ]
      },
    },
    methods: {
      Change(checkedList) {
        this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
        this.checkAll = checkedList.length === this.plainOptions.length;
      },
      onCheckAllChange(e) {
        let checkedAllList = this.plainOptions.map((item)=> {
          return item.value
        })
        Object.assign(this, {
          checkedList: e.target.checked ? checkedAllList : [],
          indeterminate: false,
          checkAll: e.target.checked,
        });
      },
      onOk(value) {
        console.log('onOk: ', value);
      },
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t("请设置url.list属性!"))
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        let params = this.getQueryParams();//查询条件
        params.isAllFault = this.checkAll?1:0; 
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      readingAbnormal(record) {   //处理异常界面点击跳转
        this.$refs.readingAbnormalModal.edit(record)
        this.$refs.readingAbnormalModal.title = this.$t('处理异常')
      },
      queryUserTypeList() {   //表类型请求
        let params = {pageNo: 1,pageSize: listSize}
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
            this.userTypeList = res.result.records;
          }
        }) 
      },
      handleExportXls(fileName){
        if(!fileName || typeof fileName != "string"){
          fileName = this.$t("导出文件")
        }
        let param = {...this.queryParam};
        if(this.selectedRowKeys && this.selectedRowKeys.length>0){
          param['selections'] = this.selectedRowKeys.join(",")
        }
        param.isAllFault = this.checkAll?1:0; 
        if (!this.checkAll) {
          param.faultType = this.checkedList.join(',');
        }
        console.log("导出参数",param)
        downFile(this.url.exportXlsUrl,param).then((data)=>{
          if (!data) {
            this.$message.warning(this.$t("文件下载失败"))
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
          }else{
            let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        })
      },
      searchReset() { 
        this.checkedList= defaultCheckedList
        this.checkAll = true
        this.indeterminate = false
        this.faultType = []
        this.date=[];
        this.queryParam = {}
        this.resetAareaData()
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  .background{
    background-color:rgb(238,238,238)
  }
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>
<style scoped>
  .table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table{
    border-right: 1px solid #e8e8e8;
  }

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border:1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}

</style>